import { CONTACT_EMAIL } from "@/config";

const ITEMS = [
  "WE WON’T LAUNCH UNTIL 200 SAY YES",
  "LIMITED FIRST DROP",
  "FOUNDING TEAM CAPPED AT 200",
  "BUILT WITH ITS MEMBERS",
  "STARTING WITH SLEEP",
  CONTACT_EMAIL.toUpperCase(),
];

export default function Marquee() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-[#171512]/10 py-5"
    >
      <div className="marquee-track flex w-max items-center gap-10">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-mono text-[11px] tracking-[0.3em] text-[#171512]/35">{item}</span>
            <span className="h-1 w-1 rounded-full bg-[#171512]/25" />
          </span>
        ))}
      </div>
    </section>
  );
}
